/**
 * Archive page sidebar filters
 */ 

function archivePageFilter() {
    if ($('.c-filter-sidebar').length) {
        // Sidebar open/close
        $('.js-toggle-sidebar-filter').on('click', function(e) {
            e.preventDefault();
            toggleSidebar();
        })
        
        function toggleSidebar() {
            $('body').toggleClass('no-scroll');
            $('.c-filter-sidebar').toggleClass('is-active');
        }
    
        // Sidebar filtering
        $('.js-submit-filter').on('click', function(e) {
            e.preventDefault();

            let filteredColours = [], filteredSizes = [];
            const cards = $('.js-product-card');
            
            const colourCheckboxes = $('input[type=checkbox][data-filter="colour"]');
            colourCheckboxes.each(function(i, item) {
                if ($(item).is(':checked')) {
                    filteredColours.push($(item).val());
                }
            });

            const sizeCheckboxes = $('input[type=checkbox][data-filter="size"]');
            sizeCheckboxes.each(function(i, item) {
                if ($(item).is(':checked')) {
                    filteredSizes.push($(item).val());
                }
            });
            
            // Check which products match filtered colours
            let cardsWithColour = [];
            if (filteredColours.length > 0) {
                filteredColours.forEach(function(colour) {
                    cards.each(function(j, card) {
                        if ($(card).hasClass(colour)) {
                            cardsWithColour.push(card);
                        }
                    })
                })
            }

            // Check which products match filtered size
            let cardsWithAllFilters = []; 
            if (filteredSizes.length > 0) {
                filteredSizes.forEach(function(size) {
                    cardsWithColour.forEach(function(card) {
                        if ($(card).hasClass(size)) {
                            cardsWithAllFilters.push(card);
                        }
                    })
                })
            } else {
                cardsWithAllFilters = cardsWithColour;
            }

            // Hide/show products
            cards.hide();
            $('.js-no-products-found').hide();

            // If no filter checkboxes clicked, show all
            if (filteredSizes.length == 0 && filteredColours.length == 0) {
                cards.show();
            } 
            
            // If filter checkboxes clicked, but no results found, show message
            else if (cardsWithAllFilters.length == 0) {
                $('.js-no-products-found').show();
                toggleSidebar();
            } 
            
            // If filter checkboxes clicked and results found, show only results
            else {
                cardsWithAllFilters.forEach(function(card) {
                    $(card).show();
                })
                toggleSidebar();
            }
        });

        // Reset filters
        $('.js-reset-sidebar-filter').on('click', function(e) {
            e.preventDefault();

            // Uncheck all checkboxes in sidebar
            $('.c-sidebar-filter input[type=checkbox]').prop('checked', false);

            // Show all products
            $('.js-product-card').show();
        });
    }
}